<script>
/**
 * Descripción: Componente de loading reutilizable
 *
 * @displayName BaseSkeletonLoader
 */

export default {
  name: 'BaseSkeletonLoader',

  props: ['type']
};
</script>

<template>
  <v-row>
    <v-col>
      <v-skeleton-loader
        ref="skeleton"
        :type="type"
        class="mx-auto"
      ></v-skeleton-loader>
    </v-col>
  </v-row>
</template>
